import { computed } from 'mobx';

import MultiStepForm from '../../../../../shared/stores/models/MultiStepForm';

import { FormResponseTypesDTO } from '../../../dtos/forms.dtos';

import FormConfig from '../FormConfig';

class DefaultFormModel {
  readonly form!: MultiStepForm;
  readonly formConfig!: FormConfig;

  readonly formValidationConfig!: Record<string, any>;

  readonly designSystemType?: string;

  fieldsGraphQlConfig: Record<string, any> = {};

  constructor(formDetailsObject: FormResponseTypesDTO) {
    const {
      formConfig,
      formValidationConfig,
      formFieldsConfig,
      templateConfigDetails
    } = formDetailsObject;

    if (formFieldsConfig)
      this.form = new MultiStepForm(
        formFieldsConfig.registration_form_details,
        null
      );
    if (formValidationConfig)
      this.formValidationConfig = JSON.parse(formValidationConfig);
    if (formConfig) this.formConfig = new FormConfig(formConfig);
    if (formFieldsConfig)
      this.designSystemType = formFieldsConfig.design_system_type;

    if (templateConfigDetails) {
      templateConfigDetails.map((eachTemplate) => {
        eachTemplate.group_config_fields.map((eachGroup) => {
          eachGroup.fields.map((eachField) => {
            if (eachField.field_response_graph_ql_config) {
              this.fieldsGraphQlConfig[eachField.name] = {
                modelName:
                  eachField.field_response_graph_ql_config.app_model_name,
                fieldName:
                  eachField.field_response_graph_ql_config.model_field_name,
                sectionId: eachField.name
              };
            }
          });
        });
      });
    }
  }
  @computed
  get formInitialValues() {
    const formInitialValuesObject = {};
    this.form?.allFormFields?.forEach((eachField) => {
      formInitialValuesObject[eachField.field] = eachField.initialValue;
    });
    return formInitialValuesObject;
  }
}

export default DefaultFormModel;
